import { render } from "./NotFound404.vue?vue&type=template&id=5c7efec0"
const script = {}

import "./NotFound404.vue?vue&type=style&index=0&id=5c7efec0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__